import FormErrorMessage from '@/features/form/components/ErrorMessage'
import {
    FormCustomerKeys,
    FormKeys,
} from '@/features/pos/components/OrderFinalization/form/constants'
import ValidationStatusMessage from '@/features/ui/inputs/components/ValidationStatusMessage'
import { MeasuredStyles } from '@/features/ui/inputs/components/ValidationStatusMessage/types'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface ErrorMessageProps {
    measuredStyles: MeasuredStyles | undefined
}

const ErrorMessage: FC<ErrorMessageProps> = ({ measuredStyles }) => {
    const { t } = useTranslation()

    return (
        <FormErrorMessage
            name={FormKeys.Customer}
            pathPriority={[FormCustomerKeys.Phone, FormCustomerKeys.Address]}
            render={(message) => (
                <ValidationStatusMessage
                    status="error"
                    message={t(message as any)}
                    measuredStyles={measuredStyles}
                />
            )}
        />
    )
}

export default memo(ErrorMessage)
